export enum STRIPE_ELEMENTS {
    cardNumber = 'cardNumber',
    cardExpiry = 'cardExpiry',
    cardCvc = 'cardCvc',
}